import React from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardLabelProps {
  className?: string;
  children?: React.ReactNode;
}

const CardLabel: React.FC<CardLabelProps> = ({ className, children, ...rest }) => {
  const classes = useStyles();

  return (
    <Typography className={cx(classes.completedLabel, className)} {...rest}>
      {children}
    </Typography>
  );
};

export default CardLabel;
